"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.Label = exports.TextContainer = exports.ImageContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../../assets/styles/colors");
const hexToRGB_1 = __importDefault(require("../../../../../utils/hexToRGB"));
const media_1 = require("../../../../../utils/media");
const Container = styled_components_1.default.div `
  background: ${(props) => props.$isActive
    ? props.$color
    : `linear-gradient(
          241deg,
          ${(0, hexToRGB_1.default)(colors_1.gray100, 0.4)} -2.4%,
          ${(0, hexToRGB_1.default)(colors_1.gray100, 0.0)} 94.94%
        ), ${colors_1.gray300}`};
  display: flex;
  flex-direction: column;
  align-self: stretch;
  padding: 16px 12px;
  width: 111px;
  border-radius: 8px;

  @media ${media_1.media.desktop} {
    align-self: auto;
    flex-direction: row;
    justify-content: space-between;
    width: 290px;
    border-radius: 10px;
    padding: 34px 20px;
  }
`;
exports.Container = Container;
const ImageContainer = styled_components_1.default.img `
  height: 85px;
  width: 85px;

  @media ${media_1.media.desktop} {
    height: 115px;
    width: 115px;
  }
`;
exports.ImageContainer = ImageContainer;
const TextContainer = styled_components_1.default.div `
  text-align: left;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  color: white;

  @media ${media_1.media.desktop} {
    text-align: right;
    padding-top: 0;
  }
`;
exports.TextContainer = TextContainer;
const Label = styled_components_1.default.span `
  font-size: 12px;
  font-weight: 700;

  @media ${media_1.media.desktop} {
    font-size: 16px;
    font-weight: 400;
  }
`;
exports.Label = Label;
const Header = styled_components_1.default.span `
  font-size: 42px;
  font-weight: 700;

  @media ${media_1.media.desktop} {
    font-size: 72px;
    font-weight: 600;
    padding-bottom: 5px;
  }
`;
exports.Header = Header;
